// HTML של יצירה — תמיד ב-iframe מבודד (11 §4): sandbox="" — בלי scripts, בלי טפסים, בלי popups, בלי ניווט של
// ה-top, origin אטום (אין גישה ל-parent/cookie). CSP בלי script-src ובלי connect-src (אין רשת), img רק data:.
// scripts אינם רצים: iframe עם allow-scripts יכול להדליף נתונים בניווט (location/meta refresh), שאינו כפוף ל-CSP.
// גרפים מצוירים ב-ChartBlock, לא ב-HTML.
import { BlockHead } from './Expand.tsx';
import type { HtmlBlock as HtmlBlockT } from '@aibify/core';
import { S } from './strings.ts';

export const HTML_CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:; form-action 'none'; base-uri 'none'";
/** ערך ה-sandbox: ריק = כל ההגבלות. */
export const HTML_SANDBOX = '';

export function htmlSrcDoc(html: string): string {
  return `<!doctype html><html dir="rtl" lang="he"><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${HTML_CSP}"><meta name="viewport" content="width=device-width,initial-scale=1"><style>body{margin:0;padding:8px;font-family:Heebo,system-ui,sans-serif;font-size:16px}</style></head><body>${html}</body></html>`;
}

export function HtmlBlock({ block }: { block: HtmlBlockT }) {
  return (
    <section className="ab-block" data-block-type="html" data-block-id={block.id}>
      <BlockHead titleHe={block.titleHe} />
      <iframe
        className="ab-html"
        title={block.titleHe ?? S.htmlTitle}
        sandbox={HTML_SANDBOX}
        referrerPolicy="no-referrer"
        srcDoc={htmlSrcDoc(block.html)}
        style={{ blockSize: `${block.height ?? 480}px` }}
      />
    </section>
  );
}
